import { List, Map } from "immutable";
import { loadingAsyncState } from "widgets-for-react";
import { dateOnlyFormat, moment } from "../../../../../custom_utils/moment";
export const loadMeans = (locationId)=>loadingAsyncState(()=>getMeansForLocation(locationId));
export const getMeansForLocation = async (id)=>{
    try {
        let res = await fetch(`/api/v1/ovatic/GetMeansPerLocation?locationid=${id}`);
        if (res.status != 200) return catchError(`Request failed: ${res.status} ${res.statusText}`);
        let meansResult = await res.json();
        if (meansResult.Result != 0) return catchError(meansResult.ResultText);
        return {
            kind: "result",
            value: meansResult.means,
            status: 200
        };
    } catch (e) {
        return catchError(e);
    }
};
export const loadLocation = (locationId)=>loadingAsyncState(()=>getLocation(locationId));
export const getLocation = async (id)=>{
    try {
        let res = await fetch(`/api/v1/ovatic/GetSingleLocation?locationId=${id}`);
        if (res.status != 200) return catchError(`Request failed: ${res.status} ${res.statusText}`);
        let location = await res.json();
        return {
            kind: "result",
            value: location,
            status: 200
        };
    } catch (e) {
        return catchError(e);
    }
};
export const postLocationOption = async (location, data, means)=>{
    var _location_seatplans_find;
    const date = moment(data.date).format(dateOnlyFormat);
    let moments = [];
    if (data.timeslots.morning) moments.push(moment(`${date}T08:00`), moment(`${date}T12:00`));
    if (data.timeslots.afternoon) moments.push(moment(`${date}T13:00`), moment(`${date}T17:00`));
    if (data.timeslots.evening) moments.push(moment(`${date}T18:00`), moment(`${date}T22:00`));
    moments.sort((a, b)=>a.diff(b));
    let start = moments[0].toISOString().slice(0);
    start = start.slice(0, start.indexOf('.')) + 'Z';
    let end = moments[moments.length - 1].toISOString();
    end = end.slice(0, end.indexOf('.')) + 'Z';
    const seatplanName = (_location_seatplans_find = location.seatplans.find((s)=>s.seatplanID == data.seatplanId)) === null || _location_seatplans_find === void 0 ? void 0 : _location_seatplans_find.name;
    let remarks = data.note;
    if (data.means.size > 0) {
        remarks += '\n\n';
        remarks += 'Benodigde middelen:\n\n';
        remarks += List(means).filter((m)=>data.means.has(m.meansID)).groupBy((m)=>m.category.description).map((groupedMeans, description)=>[
                description,
                '-'.repeat(description.length),
                ...groupedMeans.map((m)=>`${data.means.get(m.meansID)} x ${m.name} (${m.meansID})`).toArray(),
                ''
            ].join('\n')).join('\n');
    }
    const body = {
        LocationId: location.locationID,
        LocationName: location.name,
        SeatplanId: data.seatplanId,
        SeatplanName: seatplanName,
        StartDate: start,
        EndDate: end,
        Email: data.email,
        PhoneNumber: data.phoneNumber,
        FirstName: data.firstName,
        Infix: data.infix,
        LastName: data.lastName,
        CompanyName: data.companyName,
        Participants: data.participants,
        ExtraRemarks: remarks
    };
    let headers = new Headers();
    headers.append("content-type", "application/json");
    headers.append("X-XSRF-TOKEN", document.getElementsByName("__RequestVerificationToken")[0].value);
    const response = await fetch(`/api/v1/ovatic/PostReservation`, {
        method: "post",
        body: JSON.stringify(body),
        credentials: "include",
        headers: headers
    });
    return response.status == 200 ? {
        kind: 'result',
        status: 200,
        value: await response.json()
    } : catchError(`Request failed: ${response.status} ${response.statusText}`);
};
const catchError = (e)=>{
    console.error(e);
    return {
        kind: 'failed',
        status: 500
    };
};
export const getAvailableLocationTimes = async (date, locationId)=>{
    const from = moment(date).format(dateOnlyFormat);
    const until = moment(date).add(1, 'month').format(dateOnlyFormat);
    let res = await fetch(`/api/v1/ovatic/GetReservationsPerLocation?startDate=${from}&endDate=${until}&locationId=${locationId}`);
    let json = await res.json();
    const reservationList = json["Result"] != 0 ? List() : List(json["Reservations"]);
    const reservationRanges = reservationList.flatMap((r)=>List(r.Activities.map((a)=>moment.range(new Date(a.StartDate), new Date(a.EndDate)))));
    const datesInPicker = List(moment.range(moment(date), moment(date).endOf('month')).by('day'));
    const result = Map(datesInPicker.map((m)=>{
        const morning = moment.range(moment(m).hour(8).minutes(0), moment(m).hour(12).minutes(0));
        const afternoon = moment.range(moment(m).hour(13).minutes(0), moment(m).hour(17).minutes(0));
        const evening = moment.range(moment(m).hour(18).minutes(0), moment(m).hour(22).minutes(0));
        return [
            m.format(dateOnlyFormat),
            {
                morning: !reservationRanges.some((r)=>r.overlaps(morning)),
                afternoon: !reservationRanges.some((r)=>r.overlaps(afternoon)),
                evening: !reservationRanges.some((r)=>r.overlaps(evening))
            }
        ];
    }));
    return result;
};
